import { render, staticRenderFns } from "./WorkIconMessageAdd.vue?vue&type=template&id=6d985ea0"
import script from "./WorkIconMessageAdd.vue?vue&type=script&lang=js"
export * from "./WorkIconMessageAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports